/*
   새로운 api 파일 추가시, import-export 작업 필요
*/
import * as auth from './auth';
import * as map from './map';
import * as address from './address';
import * as posts from './posts';
import * as sites from './sites';

const api = {
  auth,
  posts,
  map,
  address,
  sites,
};
export default api;
